import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/tugboats`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/tugboats/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/tugboats/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/tugboats`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/tugboats/${itemId}`);
  },
};
